import type { PlatformConfig } from "./types";

let currentConfig: PlatformConfig | null = null;

export function setPlatformConfig(config: PlatformConfig): void {
  currentConfig = config;
}

export function getPlatformConfig(): PlatformConfig {
  if (!currentConfig) {
    throw new Error(
      "PlatformConfig not initialized. Wrap the app in PlatformProvider.",
    );
  }
  return currentConfig;
}

export function tryGetPlatformConfig(): PlatformConfig | null {
  return currentConfig;
}
